<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useMediaStore from '../../stores/media';
import useAudioTimeDisplay from '../../composables/use-audio-time-display';

type Props = {
  leftTime: string;
  rightTime: string;
};
defineProps<Props>();

const { skipFeedback, audioScrubbingTime } = storeToRefs(useMediaStore());
const { formatTime } = useAudioTimeDisplay();

const scrubTimeFormatted = computed(() =>
  audioScrubbingTime.value !== undefined ? formatTime(audioScrubbingTime.value) : '',
);
</script>

<template>
  <div class="time-display-under-slider d-flex justify-space-between align-center w-100 px-2">
    <span class="time-left font-weight-regular d-flex align-center">
      {{ leftTime }}
      <transition name="fade">
        <span
          v-if="skipFeedback"
          class="feedback-text mx-1"
          :class="skipFeedback.startsWith('+') ? 'success-text' : 'warning-text'"
        >
          ({{ skipFeedback }})
        </span>
      </transition>
      <transition name="fade">
        <span v-if="audioScrubbingTime !== undefined" class="feedback-text primary-text mx-1">
          → {{ scrubTimeFormatted }}
        </span>
      </transition>
    </span>
    <span class="time-right font-weight-regular">{{ rightTime }}</span>
  </div>
</template>

<style scoped lang="scss">
.time-display-under-slider {
  font-size: 0.75rem;
  user-select: none;
  padding-top: 4px;
}

.time-left {
  color: rgb(var(--v-theme-on-surface));
  white-space: nowrap;
}

.time-right {
  color: rgb(var(--v-theme-on-surface));
}

.feedback-text {
  font-size: 0.75rem;
  font-weight: 600;

  &.success-text {
    color: rgb(var(--v-theme-success));
  }

  &.warning-text {
    color: rgb(var(--v-theme-warning));
  }

  &.primary-text {
    color: rgb(var(--v-theme-primary));
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
